import React from 'react'

const CategoriesForm = () => {
  return (
    <div>CategoriesForm</div>
  )
}

export default CategoriesForm